import { call, put, takeLatest } from "redux-saga/effects";
import {
  addNewReconciliation,
  fetchReconciliations,
  fetchOneReconciliation,
  updateReconciliation,
} from "./reconciliationApi";

import {
    getReconciliationsStart,
    getReconciliationsSuccess,
    getReconciliationsFailure,
    addNewReconciliationStart,
    addNewReconciliationSuccess,
    addNewReconciliationFailure,
    updateReconciliationStart,
    updateReconciliationSuccess,
    updateReconciliationFailure,
    getReconciliationOneStart,
    getReconciliationOneSuccess,
    getReconciliationOneFailure,
} from "./reconciliationSlice";

import { showToast } from "../../../components";
function* fetchReconciliationsSaga(action) {
  try {
    const reconciliations = yield call(fetchReconciliations, action.payload);
    yield put(getReconciliationsSuccess(reconciliations));
  } catch (error) {
    yield put(getReconciliationsFailure(error.message));
  }
}
function* fetchOneReconciliationSaga(action) {
  try {
    const reconciliations = yield call(fetchOneReconciliation, action.payload);
    yield put(getReconciliationOneSuccess(reconciliations.data));
  } catch (error) {
    yield put(getReconciliationOneFailure(error.message));
  }
}
function* addNewReconciliationSaga(action) {
  try {
    const response = yield call(addNewReconciliation, action.payload);
    if (response.success) {
      yield put(addNewReconciliationSuccess(response.data));
      if (action.payload.onSuccess) {
        action.payload.onSuccess(response.data);
      }
    //   showToast("Client Added Successfully", "success", 3000);
    } else {
      yield put(addNewReconciliationFailure(response.error));
    //   showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    yield put(addNewReconciliationFailure(error.message));
    // showToast("Client Failed To Add", "error", 3000);
  }
}
function* updateReconciliationSaga(action) {
  try {
      console.log("saga is running..........");

    const { onSuccess, suppressToast = false, ...payload } = action.payload;
    const response = yield call(updateReconciliation, payload);
    if (response.success) {
      yield put(updateReconciliationSuccess(response.data.data));
      onSuccess(response.data.data);
      if (!suppressToast) {
        // showToast("Client Updated Successfully", "success", 3000);
      }
    } else {
      yield put(updateReconciliationFailure(response.error));
      showToast(`${response?.error || "Something went wrong"}`, "error", 3000);
    }
  } catch (error) {
    yield put(updateReconciliationFailure(error));
    showToast(`${response?.error || "Something went wrong"}`, "error", 3000);
  }
}

export function* watchFetchReconciliations() {
  yield takeLatest(getReconciliationsStart.type, fetchReconciliationsSaga);
  yield takeLatest(addNewReconciliationStart.type, addNewReconciliationSaga);
  yield takeLatest(updateReconciliationStart.type, updateReconciliationSaga);
  yield takeLatest(getReconciliationOneStart.type, fetchOneReconciliationSaga);
}
